import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const manufacturingExample: TemplateDefinition = {
  mode: "compose",
  slug: "manufacturing-example",
  version: 1,
  title: "Manufacturing",
  description: "Detect events",
  thumbnailUuid: BASE_ASSETS.manufacturingExample.uuid,
  assets: [BASE_ASSETS.manufacturingExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.manufacturingExample.uuid,
              extension: BASE_ASSETS.manufacturingExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value:
            "Determine when someone is present at either workstation. Send me a one sentence alert that specifies which station.",
        },
      },
    ],
    outputAnnotations: true,
    variables: {},
    annotationFormat: "box",
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
